import { copyText, copyFetchedText } from "./copyToClipboard";

// Copy buttons for ERB pages. <button data-copy-text="…"> copies that text;
// <button data-copy-fetch="/path"> copies what the path serves. Either says
// "Copied" for a moment — in its [data-copy-label] child if it has one, so an
// icon beside the label stays.
document.addEventListener("click", async (e) => {
  const btn = e.target.closest("[data-copy-text], [data-copy-fetch]");
  if (!btn) return;

  const text = btn.getAttribute("data-copy-text");
  try {
    await (text !== null ? copyText(text) : copyFetchedText(btn.getAttribute("data-copy-fetch")));
  } catch {
    return;
  }
  // Remember the label once, so a second click during "Copied" cannot keep it.
  const target = btn.querySelector("[data-copy-label]") ?? btn;
  target.dataset.label ??= target.textContent;
  const label = target.dataset.label;
  target.textContent = "Copied";
  window.setTimeout(() => {
    target.textContent = label;
  }, 1500);
});
